import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import {
  QualityLandingImg,
  QualityLandingCoalImgPNG,
} from "../../constant";
import { motion } from "framer-motion";

export default function QualityManagementLanding() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "50vh", md: "90vh" },
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1,
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop     
           playsInline
  preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src="/HomeBGVideo.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
          padding: { xs: 2, md: 6 },
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          margin: "0 auto",
          alignItems: "center",
        }}
      >
        {/* Title Box */}
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            maxWidth: "1200px",
            textAlign: "center",
            py: { xs: 2, md: 4 },
            mt: { xs: 2, md: 4 },
          }}
        >
          <Typography
            variant="h2"
            sx={{
              background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "24px", sm: "28px", md: "48px" },
              fontWeight: 700,
              mb: { xs: 1, md: 2 },
              lineHeight: { xs: 1.2, md: 1.5 },
              letterSpacing: { xs: "0px", md: "-2.4px" },
            }}
          >
           Optimize Quality,  
            <Box component="br" sx={{ display: { xs: "none", md: "block" } }} />
           Maximize Operational Value
          </Typography>
        </Box>

        {/* Animation Box */}
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: { xs: "200px", sm: "250px", md: "280px" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: 4, md: 10 },
          }}
        >
          <Box 
            sx={{ 
              position: "relative",
              zIndex: 2,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <motion.div
              animate={{ 
                rotate: 360
              }}
              transition={{ 
                repeat: Infinity, 
                duration: 60, 
                ease: "linear" 
              }}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%"
              }}
            >
              <img 
                src={QualityLandingCoalImgPNG} 
                alt="Coal" 
                style={{
                  maxWidth: isMobile && "400px" ,
                  maxHeight: isMobile && "400px" ,
                  objectFit: "contain"
                }}
              />
            </motion.div>
          </Box>

          {/* Content Image */}
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 3,
              width: { xs: "100%", sm: "90%", md: "70%" },
              marginBottom: '40px',
            }}
          >
            <img
              src={QualityLandingImg}
              alt="Pipe"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
